import React, { useState, useEffect } from "react";
import {Outlet } from "react-router-dom";
import {
  FaTachometerAlt,
  FaChartLine,
  FaUsers,
  FaBookOpen,
  FaChalkboardTeacher,
  FaLayerGroup,
  FaGraduationCap,
  FaStickyNote,
  FaBell, FaBullhorn,
  FaClipboardList,
  FaHeartbeat,
} from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import SidebarComponent from "./ReusableComponent/SidebarComponent";
import BreadcrumbsComponent from "./ReusableComponent/BreadcrumbComponents";
import FooterComponent from "./ReusableComponent/FooterComponent";
import versionData from "../version.json";
import "../components/ReusableComponent/Navigation.css";

const HomeIcon = () => <FaHome style={{ marginRight: '5px', height: '100%' }} />;

const version = versionData.version || "0.1.0";

const menuItems = [
  { icon: <FaTachometerAlt />, label: 'Dashboard', path: '/dashboard', matchPaths: ['/dashboard'] },
  { icon: <FaChartLine />, label: 'Performance Tracking', path: '/performance-tracking', matchPaths: ['/performance-tracking'] },
  { icon: <FaClipboardList />, label: 'Student Responses', path: '/student-responses', matchPaths: ['/student-responses'] },
  { icon: <FaGraduationCap />, label: 'Course Management', path: '/courses', matchPaths: ['/courses', '/courses/:id', '/courses/:id/update'] },
  { icon: <FaStickyNote />, label: 'Notes Management', path: '/notes', matchPaths: ['/notes', '/courses/:courseId/notes', '/courses/:courseId/topics/:topicId', '/courses/:courseId/topics/:topicId/notes/add', '/courses/:courseId/topics/:topicId/notes/:noteId/edit'] },
  { icon: <FaLayerGroup />, label: 'Batches Management', path: '/batches', matchPaths: ['/batches', '/batches/:id','meeting/:meetingNumber', '/batches/:id/update'] },
  { icon: <FaUsers />, label: 'Students Management', path: '/students', matchPaths: ['/students', '/students/:id', '/students/:id/update'] },
  { icon: <FaUsers />, label: 'Assignments Management', path: '/assignments', matchPaths: ['/assignments', '/assignments/:id', '/assignments/:id/update'] },
  { icon: <FaBookOpen />, label: 'Questions Management', path: '/questions', matchPaths: ['/questions', '/questions/:id', '/questions/:id/update'] },
  { icon: <FaBookOpen />, label: 'Tests Management', path: '/tests', matchPaths: ['/tests', '/tests/:id', '/tests/:id/update'] },
  { icon: <FaBookOpen />, label: 'Content Management', path: '#', matchPaths: [] },
  // Notes Management is accessible from Course Details → Manage Notes
  { icon: <FaChalkboardTeacher />, label: 'Trainer Management', path: '/trainers', matchPaths: ['/trainers', '/trainers/add', '/trainers/:id/update'] },
  { icon: <FaBell />, label: 'Notification Management', path: '/notifications', matchPaths: ['/notifications'] },
  { icon: <FaBullhorn />, label: 'Lead Management', path: '/leads', matchPaths: ['/leads', '/leads/list', '/leads/setup', '/leads/notifications', '/leads/registrations', '/leads/:id'] },
  { icon: <FaUsers />, label: 'User Management', path: '/users', matchPaths: ['/users', '/users/:userType/:id'] },
  { icon: <FaHeartbeat />, label: 'System Health', path: '/system-health', matchPaths: ['/system-health'] },
];
const breadcrumbRoutes = [
  { path: '/', breadcrumb: HomeIcon },
  { path: '/dashboard', breadcrumb: 'Dashboard' },
  { path: '/users', breadcrumb: 'User Management' },
  { path: '/system-health', breadcrumb: 'System Health' },
  { path: '/leads', breadcrumb: 'Lead Dashboard' },
  { path: '/leads/list', breadcrumb: 'Leads' },
  { path: '/leads/setup', breadcrumb: 'Lead Settings' },
  { path: '/leads/notifications', breadcrumb: 'Notification Log' },
  { path: '/leads/registrations', breadcrumb: 'Registrations' },
  { path: '/leads/:id', breadcrumb: 'Lead Details' },
  { path: '/users/:userType/:id', breadcrumb: 'Permissions' },
  { path: '/performance-tracking', breadcrumb: 'Performance Tracking' },
  { path: '/student-responses', breadcrumb: 'Student Responses' },
  { path: '/courses', breadcrumb: 'All Courses' },
  { path: '/courses/:id/update', breadcrumb: 'Update Course' },
  { path: '/courses/:id', breadcrumb: 'Course Details' },
  { path: '/batches', breadcrumb: 'All Batches', },
  { path: '/batches/add', breadcrumb: 'Add Batches', },
  { path: '/batches/:id/update', breadcrumb: 'Update Batches', },
  { path: '/batches/:id', breadcrumb: 'Batches Details', },
  { path: '/students', breadcrumb: 'All Students', },
  { path: '/students/add', breadcrumb: 'Add Students', },
  { path: '/students/:id/update', breadcrumb: 'Update Students', },
  { path: '/students/:id', breadcrumb: 'Students Details', },
  { path: '/assignments', breadcrumb: 'All Assignments', },
  { path: '/assignments/add', breadcrumb: 'Add Assignments', },
  { path: '/assignments/:id/update', breadcrumb: 'Update Assignments', },
  { path: '/assignments/:id', breadcrumb: 'Assignments Details', },
  { path: '/questions', breadcrumb: 'All Questions', },
  { path: '/questions/add', breadcrumb: 'Add Questions', },
  { path: '/questions/:id/update', breadcrumb: 'Update Questions', },
  { path: '/questions/:id', breadcrumb: 'Questions Details', },
  { path: '/tests', breadcrumb: 'All Tests', },
  { path: '/tests/add', breadcrumb: 'Add Tests', },
  { path: '/tests/:id/update', breadcrumb: 'Update Tests', },
  { path: '/tests/:id', breadcrumb: 'Tests Details', },
  { path: '/notes', breadcrumb: 'Notes Management' },
  { path: '/notes/add-subject', breadcrumb: 'Add Subject' },
  { path: '/notes/subjects/:subjectId', breadcrumb: 'Subject Details' },
  { path: '/notes/subjects/:subjectId/topics/:topicId', breadcrumb: 'Topic' },
  { path: '/notes/subjects/:subjectId/topics/:topicId/notes/add', breadcrumb: 'Add Note' },
  { path: '/notes/subjects/:subjectId/topics/:topicId/notes/:noteId/edit', breadcrumb: 'Edit Note' },
  { path: '/notes/subjects/:subjectId/topics/:topicId/notes/:noteId', breadcrumb: 'Note Details' },
  { path: '/courses/:courseId/notes', breadcrumb: 'Notes Management' },
  { path: '/courses/:courseId/topics/:topicId/notes/add', breadcrumb: 'Add Note' },
  { path: '/courses/:courseId/topics/:topicId/notes/:noteId/edit', breadcrumb: 'Edit Note' },
  { path: '/courses/:courseId/topics/:topicId', breadcrumb: 'Topic Content' },
  { path: '/trainers', breadcrumb: 'All Trainers' },
  { path: '/trainers/add', breadcrumb: 'Add Trainer' },
  { path: '/trainers/:id/update', breadcrumb: 'Update Trainer' },
  { path: '/notifications', breadcrumb: 'Notification Management' },
];
const Navigation = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleCollapse = () => setCollapsed(prev => !prev);
  const openMobileSidebar = () => setMobileOpen(true);
  const closeMobileSidebar = () => setMobileOpen(false);

  // Auto-collapse sidebar on tablet, auto-close mobile drawer on resize
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setCollapsed(false);
      } else if (window.innerWidth < 1024) {
        setCollapsed(true);
        setMobileOpen(false);
      } else {
        setMobileOpen(false);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="layout-container">
      {/* Mobile backdrop */}
      {mobileOpen && (
        <div className="sidebar-backdrop" onClick={closeMobileSidebar} />
      )}

      <div className={`sidebar-wrapper${mobileOpen ? ' mobile-open' : ''}`}>
        <SidebarComponent
          collapsed={collapsed}
          toggleCollapse={toggleCollapse}
          menuItems={menuItems}
          onMobileClose={closeMobileSidebar}
          mobileOpen={mobileOpen}
          version={version}
        />
      </div>

      <div className="content-wrapper">
        <div className="breadcrumbs-wrapper">
          <BreadcrumbsComponent routes={breadcrumbRoutes} onMenuClick={openMobileSidebar} />
        </div>

        <div className="outlet">
          <Outlet />
        </div>

        <FooterComponent
          version={version}
          CompanyName="© SkillVerse 2025"
        />
      </div>
    </div>
  );
};

export default Navigation;